import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-awards', {
  onLoad() {
    const thisSlider = this.container.querySelector('.featured-awards__slider');

    const settings = this.container.dataset.sliderSettings || '{}';
    const sliderSettings = JSON.parse(settings);

    if (!thisSlider) return;

    // eslint-disable-next-line no-unused-vars
    const flickity = new Flickity(thisSlider, {
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      imagesLoaded: true,
      contain: true,
      autoPlay: sliderSettings && sliderSettings.autoplay ? 1500 : false
    });
  },
});
